// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__7wZwl","inputWrap":"Table_inputWrap__2wNu8","col":"Table_col__OX993","bmiTooltip":"Table_bmiTooltip__1X2Mc"};